const RELOAD_MARKER = 'ep:chunk-recovery-at';
const RELOAD_COOLDOWN_MS = 15000;
const CHUNK_ERROR_PATTERN = /(?:ChunkLoadError|Loading chunk\s+.+\s+failed|Failed to fetch dynamically imported module|Importing a module script failed)/i;

const errorText = (reason) => [
  reason?.name,
  reason?.message,
  typeof reason === 'string' ? reason : null,
]
  .filter(Boolean)
  .join(': ');

export const isRecoverableChunkError = (reason) => CHUNK_ERROR_PATTERN.test(errorText(reason));

export const recoverFromObsoleteChunk = (runtimeWindow = globalThis?.window) => {
  if (!runtimeWindow?.location || typeof runtimeWindow.location.reload !== 'function') return false;

  const now = Date.now();
  let previous = 0;
  try {
    previous = Number(runtimeWindow.sessionStorage?.getItem(RELOAD_MARKER) || 0);
  } catch {}
  if (Number.isFinite(previous) && previous > 0 && (now - previous) < RELOAD_COOLDOWN_MS) {
    return false;
  }

  try {
    runtimeWindow.sessionStorage?.setItem(RELOAD_MARKER, String(now));
  } catch {}
  runtimeWindow.location.reload();
  return true;
};

export const installChunkRecovery = (runtimeWindow = globalThis?.window) => {
  if (!runtimeWindow?.addEventListener || runtimeWindow.__epChunkRecoveryInstalled === true) return false;
  runtimeWindow.__epChunkRecoveryInstalled = true;

  runtimeWindow.addEventListener('error', (event) => {
    const reason = event?.error || event?.message;
    if (!isRecoverableChunkError(reason)) return;
    if (recoverFromObsoleteChunk(runtimeWindow)) event?.preventDefault?.();
  });
  runtimeWindow.addEventListener('unhandledrejection', (event) => {
    if (!isRecoverableChunkError(event?.reason)) return;
    if (recoverFromObsoleteChunk(runtimeWindow)) event?.preventDefault?.();
  });
  return true;
};

installChunkRecovery();
